@let files = this.value() || [];

@if (multiple() || files.length === 0) {
    <button
        (click)="selectFile()"
        type="button"
        class="relative flex flex-col items-center justify-center w-full gap-3 lg:py-[60px] p-4 transition-all bg-white border-2 border-gray-200 border-dashed rounded-lg cursor-pointer select-none group hover:border-primary hover:bg-primary-50"
        (dragDrop)="handleFileDrop($event)"
    >
        <div
            class="absolute flex flex-col gap-2 justify-center items-center pointer-events-none size-full group-[.dragover]:opacity-100 opacity-0 z-10 bg-white transition-opacity"
        >
            <app-icon name="mdi:progress-upload" class="text-primary" />
            <span class="text-sm text-gray-800">파일을 놓아주세요</span>
        </div>

        <button type="button" class="flex items-center gap-2 px-3 py-2 border text-zinc-500 rounded-xl border-zinc-200">
            <app-icon name="material-symbols:upload" class="text-zinc-500" />
            <span>파일선택</span>
        </button>
        <span class="text-center text-zinc-500">
            첨부할 파일을 여기에 끌어다 놓거나, 파일 선택 버튼을 눌러 파일을 직접 선택해 주세요.
        </span>
    </button>
}

@if (files.length > 0) {
    @if (multiple()) {
        <div class="w-full pt-6 overflow-x-auto">
            <div
                class="w-full text-left border-collapse table-auto"
                cdkDropList
                [cdkDropListDisabled]="!multiple() || files.length === 1"
                (cdkDropListDropped)="handleDragDrop($event)"
            >
                <div class="flex flex-col gap-3">
                    @for (file of files; track $index) {
                        <div class="flex items-center justify-between px-5 py-4 border border-gray-200 rounded-xl">
                            <div class="flex items-center gap-2.5 *:text-sm w-full">
                                <span class="font-bold text-gray-800">{{ file.name }}</span>
                                <span class="text-gray-500">
                                    {{ file | fileSize }}
                                </span>
                            </div>

                            <app-icon-button icon="mdi:delete" (click)="removeFile($index)" size="sm" />
                        </div>
                    }
                </div>
            </div>
        </div>
    } @else {
        @let file = files[0];
        <section class="flex items-center justify-between w-full p-3 border border-gray-200 rounded-md">
            <div class="flex items-center w-full gap-3">
                <img [src]="file | dataUrl" [alt]="file.name" class="object-cover rounded-md size-16" />
                <div class="flex flex-col gap-2.5 *:text-sm">
                    <span class="font-bold text-gray-800">{{ file.name }}</span>
                    <span class="text-gray-500">
                        {{ file | fileSize }}
                    </span>
                </div>
            </div>
            <app-icon-button icon="mdi:delete" (click)="removeFile(0)" size="sm" />
        </section>
    }
}
